import alertToast from "Util/ToastifyUtils";
import { InterimFormRequestData } from "./InterimFormSection";
import { SERVER_URL } from "Constants";
import axios from "axios";
import useAsync from "Hooks/useAsync";
import { GenerateCreditReportStage } from "../../GenerateCreditReport";
import InlineSpinner from "Views/Components/Spinner/InlineSpinner";
import { availableCountries } from "Models/Enums/CountryCodeEnum";

async function submitInterimReportRequest(data: InterimFormRequestData, countryCode: string) {
	const countryName = availableCountries.find(country => country.code === countryCode)?.name;
	await axios.post(`${SERVER_URL}/api/support-tickets?category=InterimReport`, {
		businessEntityName: data.businessEntityName,
		companyName: data.companyName,
		companyNumber: data.companyNumber,
		companyAddress: data.companyAddress,
		zipCode: data.zipCode,
		city: data.city,
		providerProductSummary: data.providerProducts,
		countryName: countryName
	});
}

type Props = {
	submitData: InterimFormRequestData;
	countryCode: string;
	changeStage: (stage: GenerateCreditReportStage) => void;
	onClose: () => void;
}

export const InterimSubmitSection: React.FunctionComponent<Props> = ({
	submitData,
	countryCode,
	changeStage,
	onClose
}) => {
	const response = useAsync(async () => {
		const isValid = !!submitData && !!submitData.companyName && submitData.providerProducts.length > 0 && !!countryCode;
		if (!isValid) {
			alertToast("Please fill in all required fields", "error");
			changeStage("interimForm");
			return;
		}
		try {
			await submitInterimReportRequest(submitData, countryCode);
			alertToast("Your credit report request has been successfully lodged. You will be notified when the report is ready.", "success");
			onClose();
			return;
		} catch (error) {
			alertToast("Failed to lodge credit report request. Please try again or contact support", "error");
			changeStage("interimForm");
			return;
		}
	}, [submitData]);

	return (
		<>
			{response.type === "loading" && (
				<>
					<InlineSpinner />
					<p style={{display: "flex", justifyContent: "center"}}>Lodging request...</p>
				</>
			)}
			{response.type === "error" && (
				<p className="alert alert__error">Failed to lodge credit report request. Please try again or <a href="mailto:support@accessintell.com">contact support</a></p>
			)}
			{response.type === "data" && (
				<p className="alert alert__success">Report request lodged.</p>
			)}
		</>
	)
}